export const BASE_MAX_ITEM_LIMIT = 20;
